var React = require('react');

function ExternalLink (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd"},[React.createElement("path",{"d":"M10.925 5L9.022 7H3v10h10v-5.946l2-2.1V19H1V5z","key":0}),React.createElement("path",{"fillRule":"nonzero","d":"M16.068 2.829l-5.441-.062L10.613 1l8.263.088.087 8.262-1.766-.014-.061-5.334-8.337 8.337-1.12-1.12 8.39-8.39z","key":1})]));
}

ExternalLink.defaultProps = {"viewBox":"0 0 20 20"};

module.exports = ExternalLink;

ExternalLink.default = ExternalLink;
